import React, {useState} from 'react';
import Translate, {t} from "../../../../../components/Translate";
import Input from "../../../../../components-new/Input";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import TranslateProperty from "../../../../../components/TranslateProperty";
import config from "../../../../../config";
import {titleStyles} from "../../../../../utils/General";

const styles2 = {
    fullWidthContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
    },
    fullWidthCard: {
        width: '100%',
        maxWidth: '600px',
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    heading: {
        fontSize: '20px',
        fontWeight: 'bold',
        marginBottom: '15px',
        textAlign: 'center',
    },
    inputContainer: {
        margin: '10px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    templateList: {
        listStyleType: 'none',
        padding: 0,
        marginTop: '15px',
        overflow: 'auto',
        maxHeight: '55vh'
    },
    templateItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px',
        borderBottom: '1px solid #ddd',
        wordBreak: 'break-word',
    },
    deleteButton: {
        backgroundColor: '#ff4d4f',
        color: '#fff',
        border: 'none',
        padding: '5px 10px',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background 0.2s',
    },
    deleteButtonHover: {
        backgroundColor: '#d9363e',
    },
    templateText: {
        flex: 1,
        overflowWrap: 'break-word',
        paddingRight: '10px',
        whiteSpace: 'pre-wrap',
        fontFamily: 'inherit',
        fontSize: '16px',
        color: '#444',
    }
};

const CustomTemplates = ({
                             styles,
                             user,
                             addCustomTemplate,
                             setCustomTemplates,
                             deleteCustomTemplate,
                             editCustomTemplate,
                             customTemplates,
                             addNotification
                         }) => {
    const [newTemplateText, setNewTemplateText] = useState('');
    const [editingCustomTemplateId, setEditingCustomTemplateId] = useState();
    const [search, setSearch] = useState('');


    const filteredTemplates = customTemplates.filter(t =>
        t.text.toLowerCase().includes(search.toLowerCase())
    );

    const handleSaveTemplate = () => {
        if (newTemplateText.trim() === '') return;
        if (editingCustomTemplateId) {
            editCustomTemplate(editingCustomTemplateId, newTemplateText);
            setCustomTemplates(customTemplates.map(template =>
                template.id === editingCustomTemplateId
                    ? {...template, text: newTemplateText}
                    : template
            ));
            addNotification('edited', config.notificationLevels.info)
        } else {
            addCustomTemplate(newTemplateText);
            addNotification('added', config.notificationLevels.success)
        }

        setNewTemplateText('');
        setEditingCustomTemplateId(undefined);
    };

    const handleDeleteTemplate = (customTemplateId) => {
        deleteCustomTemplate(customTemplateId);
        addNotification('deleted', config.notificationLevels.info)
    };

    const handleEditTemplate = (customTemplateId) => {
        setNewTemplateText(customTemplates.filter(t => t.id === customTemplateId)[0].text);
        setEditingCustomTemplateId(customTemplateId);
    };

    return (
        <div style={styles.fullWidthContainer}>
            <div style={styles.fullWidthCard}>
                <h2 style={titleStyles.title}>
                    <Translate text="customTemplates"/>
                </h2>
                <br/>

                <div style={styles2.inputContainer}>
                    <TranslateProperty properties={[{key: 'placeholder', value: 'templateText'}]}>
                        <Input
                            style={{height: '200px'}}
                            isTextarea={true}
                            type="text"
                            value={newTemplateText}
                            onChange={(e) => setNewTemplateText(e.target.value)}
                        />
                    </TranslateProperty>
                    <BlueButton onClick={handleSaveTemplate}>
                        <Translate text="save"/>
                    </BlueButton>
                </div>

                <div style={{marginBottom: '20px', marginTop: '50px'}}>
                    <TranslateProperty properties={[{key: 'placeholder', value: 'search'}]}>
                        <Input
                            isTextarea={true}
                            resize={'none'}
                            type="text"
                            placeholder={t({text: 'search', user})}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </TranslateProperty>
                </div>

                <ul style={styles2.templateList}>
                    {filteredTemplates.map((template) => (
                        <div
                            key={template.id}
                            style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', justifyContent: 'center'}}
                        >
                            <div style={{
                                backgroundColor: 'rgb(221, 228, 246)',
                                position: 'relative',
                                padding: '15px 40px 15px 15px',
                                border: '1px solid #ddd',
                                borderRadius: '10px',
                                minHeight: '60px',
                                maxHeight: '200px',
                                minWidth: '92%',
                                maxWidth: '92%',
                                wordBreak: 'break-word',
                                overflowY: 'auto',
                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                fontSize: '15px',
                                lineHeight: '1.4',
                                display: 'flex',
                                gap: '20px',
                                justifyContent: 'space-between'
                            }}>
                                <span>{template.text}</span>
                            </div>
                            <div style={{display: 'flex'}}>
                                <button className="remove-btn"
                                        onClick={() => {
                                            handleDeleteTemplate(template.id);
                                        }}
                                >
                                    ×
                                </button>
                                <button className="edit-btn"
                                        onClick={() => handleEditTemplate(template.id)}
                                >
                                    ✎
                                </button>
                            </div>
                        </div>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default CustomTemplates;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/components/CustomTemplates.jsx